import React, { Component } from 'react';
import { User, Envelope, BookmarkSimple, House, Coin } from '@phosphor-icons/react';
import { cn, getSession, getRealNewOffersCount } from '../../lib/utils';
import { PAGE_ROUTE } from '../../lib/routes';
import type { UserRole } from '../../lib/utils';
interface SidebarProps {
  currentPage: string;
  navigate: (page: string) => void;
  role?: UserRole;
}
type NavItem = {
  label: string;
  href: string;
  Icon: ComponentType<{
    size?: number;
    weight?: any;
    className?: string;
  }>;
};
const demandItems: NavItem[] = [{
  label: 'Profil',
  href: PAGE_ROUTE.DASHBOARD_PROFIL,
  Icon: User
}, {
  label: 'Anunț',
  href: PAGE_ROUTE.DASHBOARD_ANUNT,
  Icon: House
}, {
  label: 'Oferte',
  href: PAGE_ROUTE.DASHBOARD_APLICARI,
  Icon: Envelope
}];
const supplyItems: NavItem[] = [{
  label: 'Profil',
  href: PAGE_ROUTE.DASHBOARD_PROFIL,
  Icon: User
}, {
  label: 'Oferte',
  href: PAGE_ROUTE.DASHBOARD_APLICARI,
  Icon: Envelope
}, {
  label: 'Favorite',
  href: PAGE_ROUTE.DASHBOARD_PROFILE_SALVATE,
  Icon: BookmarkSimple
}, {
  label: 'Credite',
  href: PAGE_ROUTE.PRICING,
  Icon: Coin
}];
export function Sidebar({
  currentPage,
  navigate,
  role = 'demand'
}: SidebarProps) {
  const items = role === 'supply' ? supplyItems : demandItems;
  const itemBaseCls = 'w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 cursor-pointer text-left relative';
  const sessionForCount = getSession();
  const newOffersCount = getRealNewOffersCount({
    role,
    email: sessionForCount?.email,
    slug: sessionForCount?.slug
  });
  return <>
      {/* Desktop sidebar — bg-dark-2 (shade as separator, no border) */}
      <aside className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col z-40" data-id="element-2239">
        <div className="flex flex-col flex-1 bg-dark-2 pt-20 px-4 pb-4" data-id="element-2240">
          <nav className="flex-1 space-y-1" data-id="element-2241">
            {items.map(item => {
            const isActive = currentPage === item.href;
            const isOffersItem = item.href === PAGE_ROUTE.DASHBOARD_APLICARI;
            return <button key={item.href} onClick={() => navigate(item.href)} className={cn(itemBaseCls, isActive ? 'bg-lime-4 text-lime-1' : 'text-light-3 hover:text-light-1 hover:bg-dark-3/60')} aria-current={isActive ? 'page' : undefined} data-id="element-2242">
                  <item.Icon size={20} weight={isActive ? 'fill' : 'regular'} className="shrink-0" data-id="element-2243" />
                  <span className="flex-1" data-id="element-2244">{item.label}</span>
                  {isOffersItem && newOffersCount > 0 && <span className="h-5 px-1.5 rounded-full text-xs font-bold bg-lime-1 text-dark-1 flex items-center justify-center" data-id="element-2245">
                      {newOffersCount}
                    </span>}
                </button>;
          })}
          </nav>
        </div>
      </aside>

      {/* Mobile bottom nav — bg-dark-1 with border-t for separation from content */}
      <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-dark-1 border-t border-dark-4 backdrop-blur-md" data-id="element-2246">
        <div className="flex items-center justify-around py-2" data-id="element-2247">
          {items.map(item => {
          const isActive = currentPage === item.href;
          const isOffersItem = item.href === PAGE_ROUTE.DASHBOARD_APLICARI;
          return <button key={item.href} onClick={() => navigate(item.href)} className={cn('flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-lg text-xs transition-colors cursor-pointer min-w-[64px] relative', isActive ? 'text-lime-1' : 'text-light-2 hover:text-light-1')} aria-current={isActive ? 'page' : undefined} data-id="element-2248">
                <div className="relative" data-id="element-2249">
                  <item.Icon size={20} weight={isActive ? 'fill' : 'regular'} data-id="element-2250" />
                  {isOffersItem && newOffersCount > 0 && <span className="absolute -top-1 -right-2 w-3.5 h-3.5 rounded-full bg-lime-1 text-dark-1 text-[9px] font-bold flex items-center justify-center border border-dark-1" data-id="element-2251">
                      {newOffersCount}
                    </span>}
                </div>
                <span data-id="element-2252">{item.label}</span>
              </button>;
        })}
        </div>
      </nav>
    </>;
}